import React from 'react';

import { TripsContent } from '../components/AppLayout';

export const Trips: React.FC = () => {
  return <TripsContent />;
};
